import { ResourceType, TechTile } from "~/business";
import { Colors, FontSize, Spacing } from "~/jsx/theme";
import { XAgentEffect } from "./XAgentEffect";
import { XResourceWithAmount } from "./XResourceWithAmount";
import { XTypography } from "./XTypography";
import { XArrowSvg } from "./svg";
import { useT } from "~/translation";

export const XTechTile = ({ techTile }: { techTile: TechTile }) => {
  const { tPhase } = useT();
  const { id, cost, buyEffects = [], effects: techEffects } = techTile;
  const width = 300;
  const ratio = 0.5;
  const height = width * ratio;
  const cardRadius = 8;
  const firstTechEffect = techEffects.at(0);
  const phaseTranslated = firstTechEffect
    ? tPhase(firstTechEffect.phase)
    : null;
  const borderColor = "#204a27";
  const hasMultipleEffects = techEffects.length > 1;

  return (
    <div
      style={{
        minWidth: width,
        minHeight: height,
        width,
        height,
        background: "linear-gradient(180deg, rgb(45 139 45), rgb(12 62 12))",
        color: Colors.common.white,
        borderRadius: cardRadius,
        display: "flex",
      }}
    >
      <div
        style={{
          backgroundColor: "#3b8d48",
          padding: Spacing.px4,
          borderBottomRightRadius: 5,
          borderRight: `solid 1px ${borderColor}`,
          borderBottom: `solid 1px ${borderColor}`,
          borderTopLeftRadius: cardRadius,
          height: "fit-content",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          maxWidth: "25%",
        }}
      >
        <XResourceWithAmount
          type={ResourceType.Spice}
          amount={cost}
          width={32}
        />
        {buyEffects.length > 0 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <XArrowSvg layout="vertical" size={8} />
            {buyEffects.map((effect, index) => (
              <XAgentEffect
                key={index}
                effectDescription={effect}
                context="card"
                width={24}
              />
            ))}
          </div>
        )}
      </div>
      <div
        style={{
          position: "relative",
          flex: 1,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <XTypography
          style={{
            textAlign: "center",
            backgroundColor: "#153e15",
            padding: `${Spacing.px4}px 0`,
            height: "fit-content",
            borderTopRightRadius: cardRadius,
            width: "100%",
          }}
        >
          {id}
        </XTypography>
        <div
          style={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            width: "100%",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <div style={{ margin: Spacing.px12 }}>
              {techEffects.map((techEffect, techEffectIndex) => {
                const { effects, phase } = techEffect;
                return (
                  <div key={techEffectIndex}>
                    {hasMultipleEffects && (
                      <XTypography style={{ display: "inline-block" }}>
                        {tPhase(phase)}:&nbsp;
                      </XTypography>
                    )}
                    {effects.map((effect, index) => (
                      <XAgentEffect
                        key={index}
                        effectDescription={effect}
                        width={hasMultipleEffects ? 24 : 32}
                        context="card"
                        style={{
                          fontSize: FontSize.px14,
                          display: "inline-block",
                          verticalAlign: "middle",
                        }}
                      />
                    ))}
                  </div>
                );
              })}
            </div>
          </div>
          {techEffects.length <= 1 && phaseTranslated && (
            <XTypography
              style={{
                padding: `0 ${Spacing.px4}px`,
                backgroundColor: Colors.green.dark,
                height: "100%",
                display: "flex",
                borderBottomRightRadius: cardRadius,
                borderLeft: `solid 1px ${borderColor}`,
              }}
              typographyStyle={{
                textOrientation: "sideways",
                writingMode: "vertical-rl",
                textAlign: "center",
                margin: 0,
                fontSize:
                  phaseTranslated.length < 10 ? FontSize.px16 : FontSize.px14,
              }}
            >
              {phaseTranslated}
            </XTypography>
          )}
        </div>
      </div>
    </div>
  );
};
